import { Listbox, Transition } from "@headlessui/react";
import { CheckCircleIcon, CheckIcon, ChevronUpDownIcon, HomeIcon } from "@heroicons/react/24/solid";
import { Fragment, useRef, useState } from "react";
import { nonAuthInstance } from "../../../services/axiosConfig";
import { isEmpty } from "lodash";
import SelectMenu from "../../../components/SelectMenu";

const pages = [
    { name: "회원 관리", href: "/ad/user", current: false },
    { name: "회원 신규 등록", href: "/ad/addUser", current: true },
];

const ranks = [
    { name: "남", value: "M" },
    { name: "여", value: "F" },
];
const checkOptions = [
    { name: "사용", value: "0001" },
    { name: "탈퇴", value: "0002" },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function AddUser() {
    const inputUserData = {
        userHpNo: "",
        user_pw: "",
        user_nm: "",
        user_email: "",
        user_bir: "",
        user_height: "",
        user_weight: "",
        user_sex: "",
        user_type: "",
    };

    const [selected, setSelected] = useState(ranks[0]);
    const [checked, setChecked] = useState(checkOptions[0]);
    const [cond, setCond] = useState(inputUserData);
    const [chkId, setChkId] = useState(false);

    const phoneRef = useRef();
    const pwdRef = useRef();
    const emailRef = useRef();
    const heightRef = useRef();
    const nameRef = useRef();
    const birRef = useRef();
    const weightRef = useRef();

    /**
     * 핸드폰 번호 중복 체크
     * @returns
     */
    const chkUsetId = async () => {
        console.log("cond==>", cond);
        try {
            const response = await nonAuthInstance.post("/user/find/userId/", cond);
            if (response.status === 200) {
                console.log("response.data ==>", response.data);
                if (response.data.tcnt == 0) {
                    alert("사용 가능한 전화번호 입니다.");
                    setChkId(true);
                } else if (response.data.tcnt > 0) {
                    alert("이미 등록된 전화번호 입니다");
                    setChkId(false);
                    setCond((preVal) => {
                        return {
                            ...preVal,
                            userHpNo: "",
                        };
                    });
                }
            }

            console.log("response===>", response);
        } catch (e) {
            console.log("e===>", e);
        }
    };

    const onSave = () => {
        if (isEmpty(cond.userHpNo) || cond.userHpNo == "") {
            alert("전화번호를 입력해 주세요");
            phoneRef.current.focus();
            return;
        } else if (isEmpty(cond.user_pw) || cond.user_pw == "") {
            alert("비밀번호를 입력해 주세요");
            pwdRef.current.focus();
            return;
        } else if (isEmpty(cond.user_email) || cond.user_email == "") {
            alert("이메일을 입력해 주세요");
            emailRef.current.focus();
            return;
        } else if (isEmpty(cond.user_height) || cond.user_height == "") {
            alert("키를 입력해 주세요");
            heightRef.current.focus();
            return;
        } else if (isEmpty(cond.user_nm) || cond.user_nm == "") {
            console.log("cond", cond);
            alert("이름을 입력해 주세요");
            nameRef.current.focus();
            return;
        } else if (isEmpty(cond.user_bir) || cond.user_bir == "") {
            alert("생년월일을 입력해 주세요");
            birRef.current.focus();
            return;
        } else if (isEmpty(cond.user_weight) || cond.user_weight == "") {
            console.log("cond", cond);
            alert("몸무게를 입력해 주세요");
            weightRef.current.focus();
            return;
        } else if (chkId == false) {
            alert("전화번호 중복 체크를 해주세요.");
            phoneRef.current.focus();
            return;
        }

        let condTmp = cond;
        condTmp.user_type = checked.value;
        condTmp.user_sex = selected.value;

        console.log("condTmp===>", condTmp);
        console.log("cond===>", cond);
    };

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 max-w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <a
                                    href={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </a>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <div className="isolate bg-white px-6 py-24 sm:py-10 lg:px-8 max-w-full">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mt-10">회원 신규 등록</h2>
                </div>
                <form action="#" method="POST" className="mx-auto max-w-xl sm:mt-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                        <div>
                            <label htmlFor="userId" className="block text-sm font-semibold leading-6 text-gray-900">
                                전화번호
                            </label>
                            <div className="flex justify-between">
                                <div className="mt-2">
                                    <input
                                        ref={phoneRef}
                                        value={(cond.userHpNo && cond.userHpNo) || ""}
                                        type="tel"
                                        name="userId"
                                        id="userId"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                        onChange={(e) => {
                                            setCond((preVal) => {
                                                return {
                                                    ...preVal,
                                                    userHpNo: e.target.value,
                                                };
                                            });
                                        }}
                                    />
                                </div>
                                <div className="mt-2">
                                    <button
                                        type="button"
                                        className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                        onClick={() => {
                                            chkUsetId();
                                        }}
                                    >
                                        중복확인
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userId" className="block text-sm font-semibold leading-6 text-gray-900">
                                회원권 등록
                            </label>
                            <div className="flex justify-between">
                                <div className="mt-2">
                                    <input
                                        type="text"
                                        name="userId"
                                        id="userId"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                        onChange={(e) => {
                                            setCond((preVal) => {
                                                return {
                                                    ...preVal,
                                                    userHpNo: e.target.value,
                                                };
                                            });
                                        }}
                                    />
                                </div>
                                <div className="mt-2">
                                    <button
                                        type="button"
                                        className="rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                    >
                                        확인
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userName" className="block text-sm font-semibold leading-6 text-gray-900">
                                비밀번호
                            </label>
                            <div className="mt-2">
                                <input
                                    ref={pwdRef}
                                    type="password"
                                    name="userName"
                                    id="userName"
                                    autocomplete="new-password"
                                    maxLength={30}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_pw: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="phoneNm" className="block text-sm font-semibold leading-6 text-gray-900">
                                이름
                            </label>
                            <div className="mt-2">
                                <input
                                    ref={nameRef}
                                    type="text"
                                    name="phoneNm"
                                    id="phoneNm"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_nm: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userMail" className="block text-sm font-semibold leading-6 text-gray-900">
                                이메일
                            </label>
                            <div className="mt-2">
                                <input
                                    ref={emailRef}
                                    type="email"
                                    name="userMail"
                                    id="userMail"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_email: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="birthDate" className="block text-sm font-semibold leading-6 text-gray-900">
                                생년월일
                            </label>
                            <div className=" mt-2">
                                <input
                                    ref={birRef}
                                    type="date"
                                    name="birthDate"
                                    id="birthDate"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_bir: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userStature" className="block text-sm font-semibold leading-6 text-gray-900">
                                키 <span>&#40;</span>cm
                                <span>&#41;</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    ref={heightRef}
                                    type="number"
                                    name="userStature"
                                    id="userStature"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_height: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userWeight" className="block text-sm font-semibold leading-6 text-gray-900">
                                몸무게 <span>&#40;</span>kg
                                <span>&#41;</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    ref={weightRef}
                                    type="number"
                                    name="userWeight"
                                    id="userWeight"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    onChange={(e) => {
                                        setCond((preVal) => {
                                            return {
                                                ...preVal,
                                                user_weight: e.target.value,
                                            };
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <SelectMenu labelText={"성별"} options={ranks} onSelect={setSelected} selectedId={selected.value} />
                        </div>
                        <div>
                            <SelectMenu labelText={"사용여부"} options={checkOptions} onSelect={setChecked} selectedId={checked.value} />
                        </div>
                    </div>
                    <div className="mt-10 flex justify-center">
                        <div className="mr-3">
                            <button
                                type="button"
                                className="inline-flex items-center gap-x-1.5 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                onClick={() => onSave()}
                            >
                                <CheckCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                등록
                            </button>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="rounded-md bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100"
                            >
                                목록
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
